import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
    controlsRow: {
        marginBottom: theme.spacing(2),
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    ngpSelect: {
        marginLeft: theme.spacing(2),
    },
    card: {
        marginBottom: theme.spacing(2),
    },
    sensitivityControls: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    sensitivitySliderWrap: {
        width: 200,
    },
    sensitivitySliderRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    sensitivityLabelInline: {
        whiteSpace: 'nowrap',
    },
    sensitivitySliderLabels: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: theme.spacing(0.5),
    },
    sensitivityChartCard: {
        padding: theme.spacing(1.5),
        overflow: 'visible',
    },
    automaticThresholdControlsRow: {
        paddingLeft: theme.spacing(4),
    },
    serviceDefaultsRow: {
        paddingLeft: theme.spacing(4),
    },
    serviceDefaultsRowWithReservedChartSpace: {
        minHeight: 200,
    },
    sensitivityChartInline: {
        marginLeft: theme.spacing(4),
        overflow: 'visible',
    },
}));
